export default __webpack_public_path__ + "static/media/card_xxiv_premio_abt.4c0d1d29.webp";